<!--
 * @Author: Ximen
 * @Date: 2021-03-17 15:46:49
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-21 14:03:27
-->
<template>
  <div class="bg">
    <div class="content">
      <div class="card-box">
        <a-card class="login">
          <div class="title">立即注册，免费试用</div>
          <div class="components-input-demo-presuffix">
          <a-input class="infoInput" :maxlength="11" placeholder="手机号码" v-model:value="mobile">
              <template #prefix>
                <i class="iconfont icon-mobile"></i>
              </template>
            </a-input>
            <a-input class="infoInput" placeholder="短信验证码"
            v-model:value="validCode">
              <template #prefix>
                <i class="iconfont icon-code"></i>
              </template>
              <template #suffix>
                <a class="colorBlue" v-if="!isShowTimer" @click="getRegisterCode()">获取验证码</a>
              <span style="color:#666" v-else>{{countNum}}s重新获取</span>
              </template>
          </a-input>
          <a-input-password class="infoInput" placeholder="登录密码"
           v-model:value="password" autocomplete="new-password">
            <template #prefix>
              <i class="iconfont icon-lock"></i>
            </template>
            <!-- <template #suffix>
              <i class="iconfont icon-authority_step1"></i>
            </template> -->
          </a-input-password>
          <a-input-password class="infoInput" placeholder="再次输入密码"
           v-model:value="confirmPassword" autocomplete="new-password">
            <template #prefix>
              <i class="iconfont icon-lock"></i>
            </template>
            <!-- <template #suffix>
              <i class="iconfont icon-authority_step1"></i>
            </template> -->
          </a-input-password>
            <a-input class="infoInput" placeholder="邀请码（选填）"
            v-model:value="parentInviteCode">
              <template #prefix>
                <i class="iconfont icon-code"></i>
              </template>
            </a-input>
          </div>
          <a-button type="primary" class="loginBtn" @click="registerShop()"
          :loading="loading">{{loading?'注册中...':'注册即可试用14天'}}</a-button>
          <div class="agreementInfo">
            <p>
              <a-checkbox v-model:checked="checked">
                <span style="font-size:12px">我已阅读并同意</span>
              </a-checkbox>
              <a class="colBlue" @click="ViewRelatedInformation(0)">用户协议，</a>
              <a class="colBlue" @click="ViewRelatedInformation(1)">隐私政策</a>
            </p>
            <p style="line-height:22px">
              <span>已有账号，</span>
              <a class="colBlue" v-on:click="goToLogin()">去登录</a>
            </p>
          </div>
        </a-card>
        <Cooperation />
        <p class="copyRight">© 2012 - 2021 seatent.com</p>
      </div>
    </div>
  </div>
  <a-modal v-model:visible="visible" :footer="null" :title="title" @ok="handleOk">
    <p style="height:600px;overflow:auto;">{{content}}</p>
  </a-modal>
</template>
<script lang="ts">
// @ is an alias to /src
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import { message as $message } from 'ant-design-vue';
import Cooperation from '@/components/cooperation.vue';
import privacy from '@/untils/privacy';
import environment from '@/untils/environment';
import userArg from '@/untils/userAgreement';

export default defineComponent({
  name: 'Register',
  components: {
    Cooperation,
  },
  data() {
    return {
      loginState: 'login',
      isPassWord: false,
      mobile: '',
      password: '',
      confirmPassword: '',
      validCode: '',
      parentInviteCode: '',
      checked: false,
      visible: false,
      title: '',
      content: '',
      countNum: 60,
      isShowTimer: false,
      loading: false,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    registerShop() {
      if (!this.mobile) {
        this.error('请输入用户名');
        return;
      }
      if (!this.validCode) {
        this.error('请输入验证码');
        return;
      }
      if (!this.password) {
        this.error('请输入登录密码');
        return;
      }
      if (!this.confirmPassword) {
        this.error('请再次输入登录密码');
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.error('两次密码输入不一致，请重新输入');
        return;
      }
      if (!this.checked) {
        this.error('请勾选用户协议，隐私政策');
        return;
      }
      const parm = {
        mobile: this.mobile,
        validCode: this.validCode,
        password: this.password,
        confirmPassword: this.confirmPassword,
        parentInviteCode: this.parentInviteCode,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.registerShop(parm).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.loading = true;
          // this.goToLogin();
          setTimeout(() => {
            this.success('注册成功');
            this.logIn();
          }, 3000);
        } else {
          this.error(message);
        }
      });
    },
    getRegisterCode() {
      if (!this.mobile) {
        this.error('请输入手机号码');
        return;
      }
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      const param = {
        mobile: this.mobile,
      };
      this.countNum = 60;
      commonApi.sendRegisterCode(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.isShowTimer = true;
          const Timer = setInterval(() => {
            if (this.countNum === 0) {
              clearInterval(Timer);
              this.isShowTimer = false;
            } else {
              this.countNum -= 1;
            }
          }, 1000);
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
    ViewRelatedInformation(num: number) {
      if (num === 0) {
        this.title = '用户协议';
        this.content = userArg;
      } else {
        this.title = '隐私政策';
        this.content = privacy;
      }
      this.visible = true;
    },
    logIn() {
      const parm = {
        mobile: this.mobile,
        validCode: this.validCode,
        password: this.password,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.login(parm).then(async ({ data, success, message }: Data) => {
        if (success) {
          const {
            accountId, memberId, token, siteId,
          } = data;
          console.log(data);
          localStorage.setItem('accountId', accountId);
          localStorage.setItem('memberId', memberId);
          localStorage.setItem('token', token);
          localStorage.setItem('siteId', siteId);
          this.getShopInfo();
        } else {
          this.error(message);
          // this.$message.error(message);
        }
      });
    },
    getShopInfo() {
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      const param = {
        memberId: localStorage.getItem('memberId'),
      };
      commonApi.getShopInfo(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          if (!data.shopName) {
            this.$router.push('/');
          } else {
            const accountId = await localStorage.getItem('accountId');
            const memberId = await localStorage.getItem('memberId');
            const token = await localStorage.getItem('token');
            const siteId = await localStorage.getItem('siteId');
            setTimeout(() => {
              const loc = window.location;
              const uri = loc.host;
              const url = `http://${uri.indexOf('pre') === -1 ? 'hdsupport.saas.seatent.com' : 'hdsupport.saas.saaspre.seatent.com'}/#/callback?randomCode=42rfmhh9x73juwvw&approach=22&token=${token}&accountId=${accountId}&appkey=${environment.appkey}&siteId=${siteId}&memberId=${memberId}&link=/home/go`;
              console.log(url);
              window.location.href = url;
            }, 50);
          }
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
  },
});
</script>
<style lang="stylus" scoped>
  .bg
    background url('../../assets/background.jpg') no-repeat;
    background-size 100% 100%
    width 100%
    .content
      height 100vh
      padding-top 130px
    .card-box
      height 650px
      display flex
      justify-content center
  .colorBlue
    color #3281DD
  .login
    border-radius 20px
    width 548px
    margin-right 11px
    padding:26px
    .titleLogin
      font-size 26px
      font-weight bold
      color #073D7D
      margin-bottom 19px
      display flex
      div
        flex 1
        text-align center
        cursor pointer
    .title
      font-size 24px
      font-weight bold
      color #073D7D
      margin-bottom 19px
    .infoInput
      margin-bottom 20px
      height 50px
    .loginBtn
      width 100%
      height 50px
      margin-top 10px
      border-radius 5px
      background #3281DD
    .selected
      color #073D7D
      opacity 0.5
    .agreementInfo
      margin-top 32px
      display flex
      font-size 12px
      flex-direction row
      justify-content space-between
      .colBlue
        color #3281DD
  .copyRight
    position fixed
    bottom 26px
    font-size 12px
    color #989898
</style>
